import { render, staticRenderFns } from "./NormalText1.vue?vue&type=template&id=83dd786a"
import script from "./NormalText1.vue?vue&type=script&lang=js"
export * from "./NormalText1.vue?vue&type=script&lang=js"
import style0 from "./NormalText1.vue?vue&type=style&index=0&id=83dd786a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports